// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__usKQF","label":"style_label__vkMPt","label-selected":"style_label-selected__9MSMz"};